import type { MapStateToProps } from 'types/redux';
import type { SiteSegmentEmptyStateOwnProps } from './SiteSegmentEmptyState';
import { backgroundUtils, colors } from '#packages/util';

const PERCEIVED_LIGHTNESS_THRESHOLD = 0.5;
const isLightColor = (color: string) =>
  colors.getLumaPerceivedLightness(color) > PERCEIVED_LIGHTNESS_THRESHOLD;

export interface SiteSegmentEmptyStateStateProps {
  isLightTextColor: boolean;
}

export const mapStateToProps: MapStateToProps<
  SiteSegmentEmptyStateStateProps,
  SiteSegmentEmptyStateOwnProps
> = ({ editorAPI, dsRead }) => {
  const backgroundData = dsRead.pages.background.get(
    dsRead.pages.getCurrentPageId(),
    'desktop',
  );

  const pageBackgroundColor = backgroundUtils.getColorValue(
    editorAPI,
    backgroundData.ref.color,
  );

  // TODO: probably add check for header/footer background instead
  const isLightTextColor = !isLightColor(pageBackgroundColor);

  return {
    isLightTextColor,
  };
};
